import EntityType from '@enums/EntityType';

const ActionType = Object.freeze({
  [EntityType.ACTIVITY]: 'activities',
  [EntityType.ROLE]: 'roles',
  [EntityType.GROUP]: 'groups',
});

export default function getActionName(entityType, action) {
  return `${ActionType[entityType]}.${action || 'update'}`;
}
